import React from 'react'
import { Tabs } from 'antd'
import { bedsMockData } from './utils/mockdata'
import useBedFilters from './hooks/useBedFilters'
import useBedModals from './hooks/useBedModals'
import BedManagementHeader from './Components/BedManagementHeader'
import BedFilters from './Components/BedFilters'
import BedTable from './Components/BedTable'
import WardSummary from './Components/WardSummary'
import AssignPatientModal from './Components/AssignPatientModal'
import TransferPatientModal from './Components/TransferPatientModal'

const { TabPane } = Tabs

const BedManagement = () => {
  // Use custom hooks
  const {
    searchText,
    setSearchText,
    wardFilter,
    setWardFilter,
    statusFilter,
    setStatusFilter,
    wards,
    filteredData,
    wardSummaryData
  } = useBedFilters(bedsMockData)

  const {
    isAssignModalVisible,
    isTransferModalVisible,
    selectedBed,
    form,
    showAssignModal,
    showTransferModal,
    handleCancel,
    handleAssign,
    handleTransfer
  } = useBedModals()

  return (
    <div style={{ padding: '24px' }}>
      <BedManagementHeader />

      <Tabs defaultActiveKey='list'>
        <TabPane tab='Bed List' key='list'>
          {/* Filters for bed list */}
          <BedFilters
            searchText={searchText}
            setSearchText={setSearchText}
            wardFilter={wardFilter}
            setWardFilter={setWardFilter}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            wards={wards}
          />

          {/* Bed List Table */}
          <BedTable bedsData={filteredData} showAssignModal={showAssignModal} showTransferModal={showTransferModal} />
        </TabPane>

        <TabPane tab='Ward Summary' key='summary'>
          <WardSummary wardSummaryData={wardSummaryData} />
        </TabPane>
      </Tabs>

      {/* Modals */}
      <AssignPatientModal
        isVisible={isAssignModalVisible}
        onCancel={handleCancel}
        onAssign={handleAssign}
        form={form}
      />

      <TransferPatientModal
        isVisible={isTransferModalVisible}
        onCancel={handleCancel}
        onTransfer={handleTransfer}
        form={form}
        selectedBed={selectedBed}
        wards={wards}
      />
    </div>
  )
}

export default BedManagement
